import styled from "styled-components";
import { gridConfig } from "@tvg/fuse-responsive-grid";

export const StyledBrandWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-space8);
  padding: var(--spacing-space8) 0;
  overflow: hidden;
  width: calc(100% + var(--spacing-space16));

  @media screen and (min-width: ${gridConfig.m.minWidth}) {
    width: calc(100% + var(--spacing-space24));
  }

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    width: 100%;
    gap: 0;
    padding: 0 0 var(--spacing-space12);
  }
`;

export const DeviceWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  display: flex;
  flex-wrap: nowrap;

  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    display: block;
    overflow-x: hidden;
  }
`;

export const WhiteRightShadow = styled.div`
  position: absolute;
  right: 0;
  width: 21px;
  height: 50px;
  flex-shrink: 0;
  background: linear-gradient(-90deg, #fff 0%, rgba(255, 255, 255, 0) 100%);
  box-shadow: 0px 2px 16px 0px rgba(255, 255, 255, 0.2);
`;

export const StyledBrandsContainer = styled.ul`
  display: flex;
  flex: 0 0 auto;
  list-style: none;
  flex-wrap: nowrap;
  padding: 0 var(--spacing-space8) 0 var(--spacing-space8);

  @media screen and (min-width: ${gridConfig.m.minWidth}) {
    padding-right: var(--spacing-space24);
  }

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    display: block;
    padding: var(--spacing-space4) var(--spacing-space24) var(--spacing-space4)
      var(--spacing-space8);
  }
`;
